export interface ClaimPropertiesKey {
  key: string;
}

export enum ClaimPropertiesActionTypes {
  REFRESH,
}

export interface RefreshClaimPropertiesKey {
  type: ClaimPropertiesActionTypes.REFRESH;
  payload: ClaimPropertiesKey;
}

export type ClaimPropertiesActions = RefreshClaimPropertiesKey;
